export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT = 5;
export const PERPAGE = 10;
export const KEY = '61123122-1d47-4a82-896b-833697f1069c';
